import { useQuery } from "@tanstack/react-query";
import { getQueryFn } from "@/lib/queryClient";
import { useAuth } from "@/hooks/useAuth";

export interface PlatformPermissions {
  isPlatformOwner: boolean;
  effectivePermissions: string[];
}

export function usePlatformPermissions() {
  const { isAuthenticated } = useAuth();
  const query = useQuery<PlatformPermissions | null>({
    queryKey: ["/api/platform/permissions/me"],
    queryFn: getQueryFn({ on401: "returnNull" }),
    enabled: isAuthenticated,
    staleTime: 15_000,
  });
  const permissions = query.data?.effectivePermissions ?? [];
  return {
    ...query,
    isPlatformOwner: query.data?.isPlatformOwner === true,
    permissions,
    hasPermission: (...required: string[]) =>
      query.data?.isPlatformOwner === true || required.some(permission => permissions.includes(permission)),
  };
}